import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { OuiInfosBulle } from 'omnium-ui/infos-bulle';
import { InvestorDeletionRuleEvaluation } from '../../../../core/models/api.models';

@Component({
  selector: 'dbw-investor-deletion-score-details',
  imports: [OuiInfosBulle],
  template: `
    <div class="score-details">
      <oui-infos-bulle
        [bulleTitle]="'Détail du score investisseur ' + investorId()"
      >
        @if (evaluations().length > 0) {
          @for (
            evaluation of evaluations();
            track evaluation.ruleName + '-' + evaluation.score + '-' + evaluation.reason
          ) {
            <div class="score-explanation">
              <strong>{{ evaluation.ruleName }} (+{{ evaluation.score }})</strong>
              <p>{{ evaluation.reason }}</p>
            </div>
          }
        } @else {
          <div class="score-explanation">
            <p>Aucune règle bonifiante appliquée à ce candidat.</p>
          </div>
        }
      </oui-infos-bulle>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: `
    :host {
      display: contents;
    }

    .score-details {
      display: inline-flex;
      align-items: center;
      gap: 0.35rem;
    }

    .score-explanation {
      display: grid;
      gap: 0.2rem;
      margin-bottom: 0.75rem;
    }

    .score-explanation:last-child {
      margin-bottom: 0;
    }

    .score-explanation p {
      margin: 0;
    }
  `
})
export class InvestorDeletionScoreDetailsComponent {
  readonly investorId = input.required<number>();
  readonly evaluations = input.required<InvestorDeletionRuleEvaluation[]>();
}
